import { render, staticRenderFns } from "./WhatIfScenarioWorkflowComment.vue?vue&type=template&id=61456414&"
import script from "./WhatIfScenarioWorkflowComment.vue?vue&type=script&lang=js&"
export * from "./WhatIfScenarioWorkflowComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports